const inject = ['frequencies', 'subscriptionService', 'toastService'];

function FrequencyControlControllerFactory(frequencies, subscriptionService, toastService) {
  class FrequencyControlController {
    constructor() {
      this.loading = false;
      this.subFrequencies = frequencies;
    }

    updateFreq(sub, frequency) {
      if (!this.loading) {
        this.loading = true;
        const translation = {
          FREQ_EVERY_PERIOD_KEY: frequency.translateEveryPeriodKey,
          every: frequency.every
        };

        subscriptionService.setFrequency(sub, frequency)
          .then(() => toastService.translate.success('TOAST_FREQUENCY_UPDATE_SUCCESS', translation))
          .catch(() => toastService.translate.danger('TOAST_FREQUENCY_UPDATE_DANGER'))
          .finally(() => {
            this.loading = false;
          });
      }
    }
  }

  return new FrequencyControlController();
}

FrequencyControlControllerFactory.$inject = inject;

module.exports = {
  module: 'msi.frequency.control.controller',
  name: 'FrequencyControlController'
};

angular.module(module.exports.module, [])
  .controller(module.exports.name, FrequencyControlControllerFactory);
